export const ContactsForm = () => {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSeNUW9t-HJT4zWw3nRf87Yon1j0iPfqSdmIIahxLbQAu41ZVQ/viewform', '_blank');
};
